import './ProductDetail.css';

const PRODUCT_DATA = {
    queue: {
        title: 'Queue',
        tagline: 'Virtual queue management for billing counters and trial rooms.',
        description: 'The foundation everything else is built on. Streamline customer flow, reduce perceived wait times, and improve operational efficiency with our core product. Perfect for handling high-traffic periods in retail environments.',
        badge: 'Core Product — Live Now'
    },
    analytics: {
        title: 'Analytics',
        tagline: 'Real-time dashboard for store managers — footfall, wait times, conversion gaps, staff performance.',
        description: 'Your SaaS monetization engine. Track key performance indicators in real-time to optimize store operations, identify bottlenecks, and drive revenue through data-driven decisions.',
        badge: 'Enterprise Insights'
    },
    loyalty: {
        title: 'Loyalty',
        tagline: 'In-app rewards and points system for end users.',
        description: "Plug-and-play loyalty infrastructure for stores that don't have one. Foster customer retention with seamless rewards programs integrated directly into the shopping journey.",
        badge: 'User Engagement'
    },
    notify: {
        title: 'Notify',
        tagline: 'Smart push notifications — queue updates, promotional triggers, abandoned queue win-backs, and wait-time alerts.',
        description: 'Keep customers informed and engaged throughout their visit. Automated notifications ensure a seamless flow and high customer satisfaction.',
        badge: 'Smart Comms'
    },
    reserve: {
        title: 'Reserve',
        tagline: 'Advance slot booking for trial rooms and billing counters before the customer even enters the store.',
        description: 'Elevate the shopping experience by allowing customers to secure their spot ahead of time. Optimize resource planning and build customer anticipation.',
        badge: 'Booking Engine'
    },
    ads: {
        title: 'Ads',
        tagline: 'Queue feed branded promotions and offers — for both store owners and third-party brands.',
        description: 'Turn waiting time into prime advertisement space. Monetize traffic with targeted offers displayed to customers while they wait for their turn.',
        badge: 'Monetization'
    },
    flow: {
        title: 'Flow',
        tagline: 'Staff allocation intelligence and peak-hour predictions.',
        description: 'Tells managers when to open counters and how to deploy floor staff. Advanced analytics predict demand rhythms to ensure smooth store operations at all times.',
        badge: 'Operational Intelligence'
    },
    connect: {
        title: 'Connect',
        tagline: 'POS and inventory system integrations.',
        description: 'Bridges with existing billing software like Gofrugal, Marg, and Unicommerce. Ensure data consistency and streamline cross-platform workflows.',
        badge: 'Integrations'
    },
    enterprise: {
        title: 'Enterprise',
        tagline: 'Multi-store chain management for retail groups.',
        description: 'Single dashboard across all locations for regional and HQ-level visibility. Robust management tools for scaling retail operations across multiple geographies.',
        badge: 'Scale'
    },
    pass: {
        title: 'Pass',
        tagline: 'The Priority Pass product — skip the queue fee or subscription.',
        description: 'Allow users to pay a small fee to skip the queue. Could evolve into a monthly subscription for frequent shoppers, providing a VIP experience for every visit.',
        badge: 'Consumer-focused'
    }
};

const ProductDetail = ({ type }) => {
    const data = PRODUCT_DATA[type];
    const navigate = (path) => {
        window.history.pushState({}, '', path);
        window.dispatchEvent(new PopStateEvent('popstate'));
    };

    if (!data) return (
        <div className="product-detail">
            <div className="product-hero">
                <h1 className="product-title">Product Not Found</h1>
                <p className="product-tagline">We're sorry, we couldn't find the product you're looking for.</p>
                <button className="btn primary" onClick={() => navigate('/')}>Back to Home</button>
            </div>
        </div>
    );

    return (
        <div className="product-detail">
            <div className="product-hero">
                {data.badge && <div className="product-badge">{data.badge}</div>}
                <h1 className="product-title">{data.title}</h1>
                <p className="product-tagline">{data.tagline}</p>
                <p className="product-description">{data.description}</p>

                <div className="product-cta">
                    <button className="btn primary">Schedule a Demo</button>
                    <button className="btn secondary" onClick={() => navigate('/')}>Learn More</button>
                </div>
            </div>

            <div className="product-accent-glow" />
        </div>
    );
};

export default ProductDetail;
